import { useCallback } from "react";
import { GrammarProgress } from "../utils/grammarProgressStorage";
import { useDeviceProgress } from "./useDeviceProgress";

export function useGrammarProgress() {
    const { data: progress, update, syncStatus } = useDeviceProgress<GrammarProgress>("grammarProgress");
    const setLearned = useCallback((key: string, learned: boolean) => {
        void update(learned ? { kind: "set", key, value: "learned" } : { kind: "remove", key });
    }, [update]);
    return { progress, setLearned, syncStatus };
}
